import { render, staticRenderFns } from "./AboutInvoiceEditSetting.vue?vue&type=template&id=2caa4b43&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports